if (!customElements.get("m-app-screens-carousel")) {
  class MAppScreensCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector("[data-app-screens-viewport]");
      this.slides = Array.from(this.querySelectorAll("[data-app-screens-slide]"));
      this.prevButton = this.querySelector("[data-app-screens-prev]");
      this.nextButton = this.querySelector("[data-app-screens-next]");
      this.dots = Array.from(this.querySelectorAll("[data-app-screens-dot]"));
      this.captions = Array.from(this.querySelectorAll("[data-app-screens-caption]"));

      if (!this.viewport || this.slides.length === 0) return;

      this.loop = this.dataset.loop === "true" && this.slides.length > 2;
      this.autoplayEnabled = this.dataset.autoplay === "true" && this.slides.length > 1;
      this.autoplayDelay = Math.max(2000, Number(this.dataset.autoplayDelay) || 4500);
      this.slider = null;

      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onDotClick = this.onDotClick.bind(this);

      this.initWhenReady();

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener("shopify:block:select", this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
      this.dots.forEach((dot) => dot.removeEventListener("click", this.onDotClick));
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    initWhenReady() {
      if (window.MinimogLibs && MinimogLibs.Swiper) {
        this.initSlider();
        return;
      }

      let attempts = 0;
      const waitForSwiper = window.setInterval(() => {
        attempts += 1;
        if (window.MinimogLibs && MinimogLibs.Swiper) {
          window.clearInterval(waitForSwiper);
          this.initSlider();
        } else if (attempts > 40) {
          window.clearInterval(waitForSwiper);
        }
      }, 50);
    }

    getGap(desktop) {
      const key = desktop ? "gap" : "gapMobile";
      const value = Number(this.dataset[key]);
      return Number.isNaN(value) ? (desktop ? 24 : 16) : value;
    }

    initSlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      const locked = this.slides.length < 2;
      this.classList.toggle("is-locked", locked);

      this.slider = new MinimogLibs.Swiper(this.viewport, {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: this.getGap(false),
        speed: 700,
        threshold: 6,
        grabCursor: !locked,
        watchOverflow: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        resistanceRatio: 0.72,
        loop: this.loop,
        loopedSlides: this.loop ? this.slides.length : 0,
        autoplay: this.autoplayEnabled
          ? {
              delay: this.autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        navigation:
          this.prevButton && this.nextButton
            ? {
                prevEl: this.prevButton,
                nextEl: this.nextButton,
              }
            : false,
        breakpoints: {
          768: {
            spaceBetween: this.getGap(true),
          },
        },
        on: {
          init: (swiper) => {
            this.syncUi(swiper);
          },
          slideChange: (swiper) => {
            this.syncUi(swiper);
          },
        },
      });

      this.dots.forEach((dot) => dot.addEventListener("click", this.onDotClick));
    }

    getRealIndex(swiper) {
      if (!swiper) return 0;
      if (typeof swiper.realIndex === "number") return swiper.realIndex;
      return swiper.activeIndex || 0;
    }

    syncUi(swiper) {
      const index = this.getRealIndex(swiper);

      this.querySelectorAll("[data-app-screens-slide]").forEach((slide) => {
        slide.classList.toggle("is-active", Number(slide.dataset.appScreensSlide) === index);
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-current", active ? "true" : "false");
      });

      this.captions.forEach((caption, captionIndex) => {
        caption.classList.toggle("is-active", captionIndex === index);
      });
    }

    onDotClick(event) {
      const index = Number(event.currentTarget.dataset.appScreensDot);
      if (Number.isNaN(index) || !this.slider) return;
      if (this.loop && typeof this.slider.slideToLoop === "function") {
        this.slider.slideToLoop(index);
      } else {
        this.slider.slideTo(index);
      }
    }

    onBlockSelect(event) {
      const slide = event.target.closest("[data-app-screens-slide]");
      if (!slide || !this.contains(slide) || !this.slider) return;
      const index = Number(slide.dataset.appScreensSlide) || 0;
      if (this.loop && typeof this.slider.slideToLoop === "function") {
        this.slider.slideToLoop(index);
      } else {
        this.slider.slideTo(index);
      }
    }
  }

  customElements.define("m-app-screens-carousel", MAppScreensCarousel);
}
